module.exports = __webpack_public_path__ + "static/img/裝櫃-黃順雨.7e6355d.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/裝櫃-黃順雨.jpeg
// module id = pevV
// module chunks = 1